export default __webpack_public_path__ + "73e40e8464622845a06d2c5c1f6fc1ca.svg";